<div class="widget-card" [class.with-overlay]="overlayText">
  <loader [isVisible]="isLoading"></loader>
  <ng-content></ng-content>
  <div *ngIf="overlayText"
       class="widget-card-overlay"
       [floatingTooltip]="overlayText"
       (click)="overlayAction && overlayAction()"></div>
</div>
